var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgRefreshOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5835 3.35756C10.8955 3.14721 10.9054 2.68793 10.6027 2.46412L7.41439 0.10639C7.06168 -0.154435 6.56401 0.0933451 6.55453 0.5345L6.51813 2.22786C3.33937 2.27802 0.777832 4.89393 0.777832 8.11356C0.777832 11.3646 3.3895 14 6.61117 14C9.83283 14 12.4445 11.3646 12.4445 8.11356C12.4445 7.10146 12.1914 6.14901 11.7455 5.31717L10.6863 5.97182C11.0176 6.61243 11.2049 7.34092 11.2049 8.11356C11.2049 10.6737 9.14822 12.7491 6.61117 12.7491C4.07411 12.7491 2.01742 10.6737 2.01742 8.11356C2.01742 5.59388 4.0096 3.54373 6.49122 3.47954L6.45621 5.10822C6.44672 5.54938 6.93328 5.8187 7.29686 5.57356L10.5835 3.35756Z",
    fill: "var(--secondary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshOutlined);
export default __webpack_public_path__ + "static/media/refreshOutlined.8e7cdd5d1169ac0af750f2e294edafc4.svg";
export { ForwardRef as ReactComponent };